<template>
  <base-button class="btn-dark" :text="text" @click="$router.push(to)" />
</template>

<script>
import BaseButton from '@/views/atoms/BaseButton';
import {RouteLocationRaw} from 'vue-router';

export default {
  name: 'RouterButton',
  components: {
    BaseButton,
  },
  props: {
    text: {
      type: String,
      required: true,
    },
    to: {
      type: RouteLocationRaw,
      required: true,
    },
  },
}
</script>
